/**
 * E-book & Infographics archives: live search + load more over AJAX.
 * The grid carries data-ajax-action (fetch_ebooks / fetch_infographics) and data-empty-text.
 */
document.addEventListener('DOMContentLoaded', function () {
    var gridContainer = document.getElementById('ebook-grid-container');
    var searchInput = document.getElementById('ebook-search-input');
    var searchForm = document.getElementById('ebook-search-form');
    if (!gridContainer || !gridContainer.dataset.ajaxAction || !searchInput || !searchForm) return;

    var loadMoreBtn = document.getElementById('ebook-load-more');
    var action = gridContainer.dataset.ajaxAction;
    var emptyText = gridContainer.dataset.emptyText || 'Nothing found.';

    var currentPage = 1;
    var maxPages = loadMoreBtn ? parseInt(loadMoreBtn.getAttribute('data-max-pages'), 10) : 1;
    var searchTimeout = null;

    function fetchItems(page, search, append) {
        var formData = new FormData();
        formData.append('action', action);
        formData.append('paged', page);
        formData.append('search', search);

        if (append && loadMoreBtn) {
            loadMoreBtn.querySelector('.btn-text').textContent = 'Loading...';
        } else if (!append) {
            gridContainer.innerHTML = '<div class="loader-spinner" style="text-align:center; padding:50px; width:100%; grid-column: 1 / -1;"><svg width="40" height="40" viewBox="0 0 50 50" style="animation: spin 1s linear infinite; transform-origin: center;"><circle cx="25" cy="25" r="20" fill="none" stroke="#f26522" stroke-width="4" stroke-dasharray="80" stroke-linecap="round"></circle></svg><style>@keyframes spin { 100% { transform: rotate(360deg); } }</style></div>';
        }

        fetch(window.infinity_ajax_object.ajaxurl, { method: 'POST', body: formData })
            .then(function (response) { return response.json(); })
            .then(function (res) {
                if (!res.success) return;

                if (append) {
                    gridContainer.insertAdjacentHTML('beforeend', res.data.html);
                } else {
                    gridContainer.innerHTML = res.data.html || '<p class="no-ebooks-found">' + emptyText + '</p>';
                }

                maxPages = res.data.max_pages;

                if (loadMoreBtn) {
                    loadMoreBtn.querySelector('.btn-text').textContent = 'Load More';
                    if (page >= maxPages) {
                        loadMoreBtn.style.display = 'none';
                    } else {
                        loadMoreBtn.style.display = 'inline-flex';
                        loadMoreBtn.setAttribute('data-page', page);
                    }
                }
            })
            .catch(function (error) {
                console.error('Error fetching ' + action + ':', error);
                if (append && loadMoreBtn) {
                    loadMoreBtn.querySelector('.btn-text').textContent = 'Load More';
                }
            });
    }

    // Live search (500ms debounce)
    searchInput.addEventListener('input', function () {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function () {
            currentPage = 1;
            fetchItems(currentPage, searchInput.value.trim(), false);
        }, 500);
    });

    searchForm.addEventListener('submit', function (e) {
        e.preventDefault();
        clearTimeout(searchTimeout);
        currentPage = 1;
        fetchItems(currentPage, searchInput.value.trim(), false);
    });

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            if (currentPage < maxPages) {
                currentPage++;
                fetchItems(currentPage, searchInput.value.trim(), true);
            }
        });
    }
});
